import { ComponentProps } from 'react';

import { Box } from 'components/Box';
import { fontWeights } from 'theme';
import { isDefined } from 'utils/functional';

type Props = {
  count: number | null | undefined;
} & Pick<ComponentProps<typeof Box>, 'bg' | 'transition'>;

export function PageHeaderAccountDropdownBadge({ count, ...props }: Props) {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      width="calc(1em + 4px)"
      height="calc(1em + 4px)"
      flex="0 0 auto"
      borderRadius="50%"
      color="white"
      fontWeight={isDefined(count) ? fontWeights.normal : fontWeights.bold}
      lineHeight={1.375}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line no-nested-ternary */}
      <Box fontSize={`calc(1em - ${!count ? 1 : count > 9 ? 2 : 0}px)`}>
        {count && count > 0 && Math.min(count, 99)}
        {count && count > 99 && '+'}
      </Box>
    </Box>
  );
}
